function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

function reportInputValidity(input, errorBlock) {
  if (!input || !errorBlock) return false;

  const type = input.type;
  const value = input.value.trim();
  let isValid = true;
  let errorType = "empty";

  isValid = value === "" ? false : true;

  switch (type) {
    case "email":
      if (value !== "" && !input.checkValidity()) {        
        isValid = false;
        errorType = "email"
      }
      break;
  }

  if (isValid) {
    input.removeAttribute("aria-invalid");
    errorBlock.innerText = "";
  } else {
    input.setAttribute("aria-invalid", true);
    errorBlock.innerText = window.errorStrings[errorType];
  }

  return isValid;
}

function togglePageScroll() {
  if (document.documentElement.style.overflow == "hidden") {
    document.documentElement.style.overflow = null;
  } else {
    document.documentElement.style.overflow = "hidden";
  }
}

// Popup manager: moves any [data-popup] element into #PopupsRoot on open and
// restores it to its original spot on close. Triggered by [data-popup-open="<id>"]
// and [data-popup-close]; supports Escape and shopify:section:unload cleanup.
window.Popup = (function () {
  const openPopups = new Map();

  function getRoot() {
    return document.getElementById("PopupsRoot");
  }

  function findPopup(id) {
    return document.querySelector(`[data-popup="${id}"]`);
  }

  function open(popup) {
    const root = getRoot();
    if (!root || !popup || openPopups.has(popup)) return;

    const placeholder = document.createComment("popup-slot");
    popup.parentNode.insertBefore(placeholder, popup);
    root.appendChild(popup);

    openPopups.set(popup, { placeholder });

    if (openPopups.size === 1) {
      document.documentElement.style.overflow = "hidden";
    }

    requestAnimationFrame(() => {
      popup.classList.add("open");
    });
  }

  function close(popup) {
    if (!popup || !openPopups.has(popup)) return;

    const { placeholder } = openPopups.get(popup);
    popup.classList.remove("open");

    let done = false;
    const cleanup = () => {
      if (done) return;
      done = true;

      if (placeholder.parentNode) {
        placeholder.replaceWith(popup);
      }
      openPopups.delete(popup);

      if (openPopups.size === 0) {
        document.documentElement.style.overflow = null;
      }
    };

    popup.addEventListener("transitionend", cleanup, { once: true });
    setTimeout(cleanup, 500);
  }

  function closeAll() {
    Array.from(openPopups.keys()).forEach(close);
  }

  document.addEventListener("click", (event) => {
    const openBtn = event.target.hasAttribute("data-popup-open") ? event.target : false;
    if (openBtn) {
      open(findPopup(openBtn.dataset.popupOpen));
      return;
    }

    const closeBtn = event.target.hasAttribute("data-popup-close") ? event.target : false;
    if (closeBtn) {
      close(closeBtn.closest("[data-popup]"));
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape" || openPopups.size === 0) return;
    const last = Array.from(openPopups.keys()).pop();
    close(last);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const sectionId = event.detail.sectionId;
    const root = getRoot();
    if (!root) return;

    root.querySelectorAll(`[data-section-id="${sectionId}"]`).forEach((popup) => {
      if (openPopups.has(popup)) {
        openPopups.delete(popup);
        popup.classList.remove("open");
        popup.remove();
      }
    });

    if (openPopups.size === 0) {
      document.documentElement.style.overflow = null;
    }
  });

  return {
    open: (id) => open(findPopup(id)),
    close: (id) => close(findPopup(id)),
    closeAll,
  };
})();

// --- SECTIONS --- //

class Header {
  constructor(root) {
    this.root = root;
    this.mobileMenu = this.root.querySelector("#HeaderMobileMenu");
    this.allAnnouncementsHeight = 0;
    this.menuOpen = false;

    this.root.addEventListener('click', this.onClick.bind(this));
    
    this.calcHeader();
    window.addEventListener('scroll', () => {
      this.root.classList.toggle('sticky', window.scrollY >= this.allAnnouncementsHeight);
    });

  }

  calcHeader() {
		const headerObserver = new ResizeObserver(() => {
			this.headerHeight = this.root.getBoundingClientRect().height;

      const announcements = document.querySelectorAll(".announcement");
      this.allAnnouncementsHeight = Math.max(Array.from(announcements).reduce((sum, el) => {
        return sum + el.offsetHeight;
      }, 0), 1);
      
      document.documentElement.style.setProperty('--menu-height', `${this.headerHeight + this.allAnnouncementsHeight}px`);
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      this.root.classList.toggle('sticky', window.scrollY >= this.allAnnouncementsHeight);
		});

		headerObserver.observe(this.root);
	}

  onClick(event) {
    if (!event.target.hasAttribute("data-action")) return;

    switch (event.target.dataset.action) {
      case "menu-toggle":
        this.toggleMobileMenu();
        break;
      case "submenu-toggle":
        const sub = event.target.nextElementSibling;

        event.target.classList.toggle("open");
        sub.style.maxHeight = event.target.classList.contains("open") ?  sub.scrollHeight + "px" : null;        
        break;
    }
  }

  toggleMobileMenu() {
    if (!this.mobileMenu.classList.contains("open")) {
      this.setMenuOffset();
      this.mobileMenu.classList.add("open");
      document.documentElement.style.overflow = "hidden";
    } else {
      this.mobileMenu.classList.remove("open");
      document.documentElement.style.overflow = null;
    }
  }

  setMenuOffset() {
    const offset = Math.max(this.root.getBoundingClientRect().bottom, 0);
    this.mobileMenu.style.setProperty("--menu-offset", `${offset}px`);
  }
}

if (document.querySelector("header")) {
  new Header(document.querySelector("header"))
}

// Animation functionality 

document.addEventListener('DOMContentLoaded', () => {
  initJsAnimations();
});

function initJsAnimations(userOpts = {}) {
  const opts = {
    sectionPxToTrigger: 150,
    cardThreshold: 0.2,
    sectionDuration: 0.7,
    cardDuration: 0.6,
    cardDelayStep: 0.3,
    rootMargin: '0px',
    once: true,
    ...userOpts
  };

  const sections = Array.from(document.querySelectorAll('[js-animation]'));
  if (!sections.length) return;

  sections.forEach(sec => {
    const sectionPxToTrigger = getNumber(sec.dataset.sectionPx, opts.sectionPxToTrigger);
    const sectionDuration = getNumber(sec.dataset.sectionDuration, opts.sectionDuration);
    const cardDuration = getNumber(sec.dataset.cardDuration, opts.cardDuration);
    const cardDelayStep = getNumber(sec.dataset.cardDelayStep, opts.cardDelayStep);

    sec.style.setProperty('--section-dur', `${sectionDuration}s`);
    sec.style.setProperty('--card-dur', `${cardDuration}s`);
    sec.style.setProperty('--card-delay-step', `${cardDelayStep}s`);

    // Збережемо опції секції
    sec.__animOpts = { sectionPxToTrigger, cardDelayStep };
  });

  // Спостерігач для карток лишаємо (threshold по картці як було)
  const cardObserver = new IntersectionObserver(onCardsIntersect, {
    root: null,
    rootMargin: opts.rootMargin,
    threshold: buildThresholds(opts.cardThreshold)
  });

  sections.forEach(sec => {
    getCards(sec).forEach(card => {
      const order = Number(card.getAttribute('js-animation-block')) || 0;
      card.__order = order;
      card.__animated = false;
      cardObserver.observe(card);
    });
  });

  const pending = new Set(sections);
  let ticking = false;

  function checkSections() {
    ticking = false;
    const viewportH = window.innerHeight || document.documentElement.clientHeight || 0;

    pending.forEach(sec => {
      const rect = sec.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= viewportH) {

        if (!opts.once) {
          sec.classList.remove('is-animated');
          getCards(sec).forEach(c => {
            c.__animated = false;
            c.classList.remove('is-animated');
            c.style.transitionDelay = '';
          });
        }
        return;
      }

      const needPx = Math.min(sec.__animOpts.sectionPxToTrigger, rect.height);
      const firstChunkVisible = rect.top <= (viewportH - needPx);

      if (firstChunkVisible) {
        if (!sec.classList.contains('is-animated')) {
          sec.classList.add('is-animated');
        }
        if (opts.once) pending.delete(sec);
      } else if (!opts.once) {
        sec.classList.remove('is-animated');
        getCards(sec).forEach(c => {
          c.__animated = false;
          c.classList.remove('is-animated');
          c.style.transitionDelay = '';
        });
      }
    });
  }

  function onScrollOrResize() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(checkSections);
    }
  }

  onScrollOrResize();
  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);

  let rafScheduled = false;
  const pendingVisibleBySection = new Map();

  function onCardsIntersect(entries) {
    for (const entry of entries) {
      const card = entry.target;
      const sec = findSection(card);
      if (!sec) continue;

      const isVisible = entry.isIntersecting && entry.intersectionRatio > 0;
      if (isVisible && !card.__animated) {
        if (!pendingVisibleBySection.has(sec)) pendingVisibleBySection.set(sec, new Set());
        pendingVisibleBySection.get(sec).add(card);
      }

      if (!isVisible && !opts.once && card.__animated) {
        card.__animated = false;
        card.classList.remove('is-animated');
        card.style.transitionDelay = '';
      }
    }

    if (!rafScheduled) {
      rafScheduled = true;
      requestAnimationFrame(flushVisibleBatches);
    }
  }

  function flushVisibleBatches() {
    rafScheduled = false;
    for (const [sec, setOfCards] of pendingVisibleBySection.entries()) {
      if (!sec.classList.contains('is-animated')) continue;

      const delayStep = sec.__animOpts?.cardDelayStep ?? opts.cardDelayStep;

      const batch = Array.from(setOfCards)
        .filter(c => !c.__animated)
        .sort((a, b) => (a.__order || 0) - (b.__order || 0));

      batch.forEach((card, idx) => {
        card.style.transitionDelay = `${idx * delayStep}s`;
        card.classList.add('is-animated');
        card.__animated = true;
      });

      setOfCards.clear();
    }
  }

  function getCards(sectionEl) {
    return Array.from(sectionEl.querySelectorAll('[js-animation-block]'));
  }

  function findSection(el) {
    return el.closest('[js-animation]');
  }

  function buildThresholds(minRatio) {
    const steps = 10;
    const arr = [];
    for (let i = 0; i <= steps; i++) arr.push(i / steps);
    if (!arr.includes(minRatio)) arr.push(minRatio);
    return arr.sort((a, b) => a - b);
  }

  function getNumber(val, fallback) {
    const n = Number(val);
    return Number.isFinite(n) ? n : fallback;
  }
}

class FeaturedProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.dataset.type == "recommendations") {
      this.setRecommendationProducts();
    }
  }

  setRecommendationProducts() {
    const recommendationLink = window.Shopify.routes.root + `recommendations/products?limit=4&product_id=${this.dataset.product}&intent=${this.dataset.recommendations}&section_id=${this.dataset.section}`;
      fetch(recommendationLink)
      .then(response => response.text())
      .then(response => {
        const html = new DOMParser().parseFromString(response, "text/html");

        if (html.querySelector("featured-products[data-empty]")) {
          this.style.display = "none";
          return;
        }
        
        const grid = this.querySelector('[id^="Slider-"]');
        grid.innerHTML = html.querySelector('[id^="Slider-"]').innerHTML;

        this.querySelector("slider-component").update();
      })
      .catch(error => console.error(error))
  }
}

if (document.querySelector("featured-products")) {
  customElements.define("featured-products", FeaturedProduct);
}

class MainProduct extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
    this.cart = document.querySelector("cart-drawer");
    this.alternatePages;
    this.alternatePagesUrls = [];

    if (this.querySelectorAll("[data-page]").length > 1) {
      this.fetchPages();
    }
  }
  
  connectedCallback() {
    this.productVariants = JSON.parse(this.querySelector("[data-variants-data]").textContent);
    this.productGallery = this.querySelector('[id^="ProductGallery-"]');
    this.productForm = this.querySelector('[id^="ProductForm-"]');
    this.productQuantityOptions = this.querySelector('[id^="ProductQuantityOptions-"]');

    this.giftDenominations = this.querySelector("[data-denominations]");
    this.giftMessage = this.querySelector("[data-gift-message]");

    this.productGallery?.addEventListener('slider-updated', this.updateGallery.bind(this));
    this.productQuantityOptions?.addEventListener("change", this.onQuantityChange.bind(this));
    this.giftDenominations?.addEventListener("change", this.onDenominationChange.bind(this));
    this.giftMessage?.addEventListener("input", this.updateGiftCounter.bind(this));
    this.productForm?.addEventListener("submit", this.onFormSubmit.bind(this));
    this.initClickListeners();
  }

  onDenominationChange() {
    const selected = this.giftDenominations.querySelector("input:checked");
    if (!selected) return;

    const idInput = this.querySelector("[name='id']");
    if (idInput) idInput.value = selected.dataset.variantId;

    const price = this.querySelector('[data-content="price"]');
    const compare = this.querySelector('[data-content="compare"]');

    if (price) price.innerHTML = selected.dataset.price || "";
    if (compare) compare.innerHTML = selected.dataset.compare || "";
  }

  updateGiftCounter() {
    const counter = this.querySelector("[data-gift-counter]");
    if (!counter) return;

    const max = parseInt(this.giftMessage.getAttribute("maxlength"), 10) || 500;
    counter.textContent = max - this.giftMessage.value.length;
  }

  collectProperties() {
    const properties = {};

    this.querySelectorAll("[name^='properties[']").forEach((input) => {
      if ((input.type === "checkbox" || input.type === "radio") && !input.checked) return;

      const match = input.name.match(/^properties\[(.+)\]$/);
      if (!match) return;

      const value = input.value.trim();
      if (value === "") return;

      properties[match[1]] = value;
    });

    return properties;
  }

  onQuantityChange() {
    const selected = this.productQuantityOptions.querySelector("input:checked");
    if (!selected) return;

    const quantityInput = this.querySelector("[name='quantity']");
    if (quantityInput) quantityInput.value = selected.value;

    const price = this.querySelector('[data-content="price"]');
    const compare = this.querySelector('[data-content="compare"]');
    const packageInfo = this.querySelector('[data-content="package"]');

    if (price) price.innerHTML = selected.dataset.price || "";
    if (compare) compare.innerHTML = selected.dataset.compare || "";
    if (packageInfo) packageInfo.innerHTML = selected.dataset.note || "";
  }

  onFormSubmit(event = false, skipUpgrade = false) {
    if (event) event.preventDefault();

    if (this.isLoading) return;

    if (this.dataset.giftCard === "true") {
      const emailInput = this.querySelector("[name='properties[Recipient email]']");
      if (emailInput && !emailInput.reportValidity()) return;
    }

    const sections = [];
    if (this.cart) sections.push("cart-drawer");

    const item = {
      id: parseInt(this.querySelector("[name='id']").value),
      quantity: parseInt(this.querySelector("[name='quantity']").value)
    };

    const properties = this.collectProperties();
    if (Object.keys(properties).length) item.properties = properties;

    const cartData = {
      items: [item],
      sections: sections,
      sections_url: window.location.pathname
    };

    this.addToCart(cartData);
  }

  getSelectedDiscountCode() {
    const checkedOption = this.productQuantityOptions?.querySelector("input:checked");
    return checkedOption?.dataset.discountCode || "";
  }

  addToCart(data) {
    if (!data) return;

    this.toggleLoading();

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) {
        const error = new Error(response.description);
        throw error;
      } else {
        this.toggleLoading();

        if (this.cart) {
          // Apply the selected option's discount code alongside the codes required by the
          // items already in the cart, then render + open. renderContent re-syncs on top.
          const extraCode = this.getSelectedDiscountCode();
          const targetDiscounts = this.cart.computeTargetDiscounts({}, extraCode ? [extraCode] : []);
          this.cart.applyDiscountsAndRender(targetDiscounts).then(() => this.cart.open());
        }
      }
    })
    .catch(error => this.showError(error))
    .finally(() => this.toggleLoading(true));
  }

  renderContent(html) {
    const section = html.querySelector(`[data-section="${this.dataset.section}"]`);
    const selectors = [
      '[id^="ProductPrice-"]',
      '[id^="ProductOptions-"]',
      '[id^="ProductSubmit-"]'
    ];

    selectors.forEach(selector => {
      const currentSelectors = this.querySelectorAll(selector);
      const newSelectors = section.querySelectorAll(selector);

      if (currentSelectors.length > 0 && currentSelectors.length == newSelectors.length) {
        currentSelectors.forEach((currentSelector, i) => {
          currentSelector.innerHTML = newSelectors[i].innerHTML;
        })
      }
    });

    if (this.querySelector('[id^="ProductSubmit-"]')) {
      const currentButton = this.querySelector('[id^="ProductSubmit-"]');
      const newButton = section.querySelector('[id^="ProductSubmit-"]');
      currentButton.toggleAttribute("disabled", newButton.disabled);
    }
  }

  initClickListeners() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-action")) {
        switch (e.target.dataset.action) {
          case "select-slide":
            const productGalleryComponent = this.productGallery?.querySelector("slider-component");
            productGalleryComponent?.scrollToSlide(e.target.dataset.index);
            break;
          case "video-play": {
            const slide = e.target.closest('[id^="Slide-"]');
            const video = slide?.querySelector("[data-product-video]");
            if (!video) break;
            if (video.paused) {
              video.play().catch(() => {});
              slide.classList.add("video-playing");
            } else {
              video.pause();
              slide.classList.remove("video-playing");
            }
            break;
          }
          case "video-mute": {
            const slide = e.target.closest('[id^="Slide-"]');
            const video = slide?.querySelector("[data-product-video]");
            if (!video) break;
            video.muted = !video.muted;
            slide.classList.toggle("video-muted", video.muted);
            break;
          }
          case "toggle-disclosure":
            const disclosureHandle = e.target.dataset.disclosure;
            const disclosureContent = this.querySelector(`[data-disclosure-content="${disclosureHandle}"]`);
              
            e.target.classList.toggle("open");

            if (e.target.classList.contains("open")) {
              disclosureContent.style.maxHeight = disclosureContent.scrollHeight + "px";
            } else {
              disclosureContent.style.maxHeight = null;
            }
            break;
        }
      }
    })
  }

  updateGallery(event) {
    const current = event.detail.currentSlide;

    this.querySelectorAll('[id^="Slider-GalleryNav-"] li').forEach(thumb => {
      thumb.classList.toggle("selected", current === parseInt(thumb.dataset.index));
    });

    this.productGallery?.querySelectorAll('[id^="Slide-"]').forEach(slide => {
      const video = slide.querySelector("[data-product-video]");
      if (!video) return;

      slide.classList.toggle("video-muted", video.muted);

      if (current === parseInt(slide.dataset.index)) {
        video.play().then(() => slide.classList.add("video-playing")).catch(() => {});
      } else {
        video.pause();
        video.currentTime = 0;
        slide.classList.remove("video-playing");
      }
    });
  }

  showError(error) {
    console.error(error);

    if (!this.querySelector("[product-notification]")) return;

    const messageBlock = this.querySelector("[product-notification]");

    messageBlock.innerText = error.message;
    setTimeout(() => {messageBlock.innerText = ''}, 5000);
    messageBlock.scrollIntoView({behavior: "smooth",block:"center"});
  }

  toggleLoading(turnOff = false) {
    this.isLoading = !this.isLoading;
    if (turnOff) this.isLoading = false;
    this.classList.toggle("loading", this.isLoading);
  }

  isInViewport(element) {
    const rect = element.getBoundingClientRect();

    let isInViewport = (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );

    if (rect.top > 0) isInViewport = true;
    
    return isInViewport;
  };
}

if (document.querySelector("main-product")) {
  customElements.define("main-product", MainProduct);
}

class MainCollection extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
    this.currentPage = 1;
    this.productsGrid = this.querySelector('[id^="CollectionGrid-"]');

    this.initClickEvents();
  }

  initClickEvents() {
    this.addEventListener("click", (e) => {
      if (!e.target.hasAttribute("data-action")) return;

      switch (e.target.dataset.action) {
        case "switch-collection":
          this.querySelector("[data-featured] .active")?.classList.remove("active");
          e.target.classList.add("active");
          this.filtersUpdate(e.target.dataset.collection);
          break;
        case "open-options":
          this.querySelector("[data-sort]").classList.toggle("open");
          break;
        case "select-option":
          this.querySelector("[name='sort_by']").value = e.target.dataset.option;
          this.querySelector("[data-sort] .active")?.classList.remove("active");
          e.target.classList.add("active");
          this.querySelector("[data-sort]").classList.remove("open");
          this.filtersUpdate();
          break;
        case "load-more":
          this.loadMoreProducts();
          break;
      }
    });

    window.addEventListener("click", (e) => {
      const sort = this.querySelector("[data-sort]");
      if (sort && !e.target.closest("[data-sort]")) {
        sort.classList.remove("open");
      }
    });
  }

  loadMoreProducts() {
    this.toggleLoading();
    this.currentPage++;

    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("page", this.currentPage);

    fetch(window.location.pathname + `?${searchParams.toString()}`)
      .then((res) => res.text())
      .then((body) => {
        const html = new DOMParser().parseFromString(body, "text/html");
        const section = html.querySelector(`[data-section="${this.dataset.section}"]`);

        const currentGrid = this.querySelector('[id^="CollectionGrid-"]');
        const newPageGrid = section.querySelector('[id^="CollectionGrid-"]');

        newPageGrid.querySelectorAll(":scope > *").forEach((item) => {
          currentGrid.append(item);
        });

        // Refresh pagination (counter / show-more visibility) but keep the grid we just appended to.
        this.renderContent(html, "[data-collection-grid]");
      })
      .catch((error) => console.error(error))
      .finally(() => this.toggleLoading());
  }

  filtersUpdate(handle = false) {
    this.toggleLoading();

    const params = new URLSearchParams();

    // Facet params come from the filters drawer; ignored when switching collections
    // (facets differ per collection).
    const drawer = document.querySelector("filters-drawer");
    if (!handle && drawer) {
      new URLSearchParams(drawer.getParams()).forEach((value, key) => params.append(key, value));
    }

    const sortInput = this.querySelector("[name='sort_by']");
    if (sortInput && sortInput.value) {
      params.set("sort_by", sortInput.value);
    }
    params.set("page", 1);
    this.currentPage = 1;

    const newProductUrl = handle
      ? `/collections/${handle}?${params.toString()}`
      : window.location.pathname + `?${params.toString()}`;

    window.history.replaceState({}, "", newProductUrl);

    fetch(newProductUrl)
      .then((res) => res.text())
      .then((body) => {
        const html = new DOMParser().parseFromString(body, "text/html");
        this.renderContent(html);
      })
      .catch((error) => console.error(error))
      .finally(() => this.toggleLoading());
  }

  renderContent(html, exclusion = false) {
    const section = html.querySelector(`[data-section="${this.dataset.section}"]`);
    const selectors = [
      "[data-collection-breadcrumbs]",
      "[data-collection-header]",
      "[data-collection-headings]",
      "[data-collection-grid]",
      "[data-collection-pagination]",
    ];

    selectors.forEach((selector) => {
      if (selector === exclusion) return;
      if (this.querySelector(selector) && section.querySelector(selector)) {
        this.querySelectorAll(selector).forEach((selectorElement, i) => {
          selectorElement.innerHTML = section.querySelectorAll(selector)[i].innerHTML;
        });
      }
    });

    this.updateFiltersCount(section);

    const drawer = document.querySelector("filters-drawer");
    if (drawer) drawer.updateOptions(html);
  }

  updateFiltersCount(section) {
    const source = section.querySelector('[name="open-filters"] [data-active-filters-count]');
    const target = this.querySelector('[name="open-filters"]');
    if (!target) return;

    const existing = target.querySelector("[data-active-filters-count]");
    if (source) {
      if (existing) {
        existing.textContent = source.textContent;
      } else {
        target.appendChild(source.cloneNode(true));
      }
    } else if (existing) {
      existing.remove();
    }
  }

  toggleLoading() {
    this.isLoading = !this.isLoading;
    this.classList.toggle("loading", this.isLoading);
  }
}

if (document.querySelector("main-collection")) {
  customElements.define("main-collection", MainCollection);
}

class FiltersDrawer extends HTMLElement {
  constructor() {
    super();
    this.onClickEvent = this.onClickEvent.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.onClickEvent);
    this.openAllOptions();
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onClickEvent);
  }

  openAllOptions() {
    this.querySelectorAll("[data-param]").forEach((option) => {
      const optionValues = option.querySelector("[data-values]");
      if (!optionValues) return;
      option.classList.add("open");
      optionValues.style.maxHeight = optionValues.scrollHeight + "px";
    });
  }

  onClickEvent(event) {
    if (!event.target.hasAttribute("data-action")) return;

    switch (event.target.dataset.action) {
      case "toggle-option": {
        const option = event.target.closest("[data-param]");
        const optionValues = option.querySelector("[data-values]");
        option.classList.toggle("open");
        optionValues.style.maxHeight = option.classList.contains("open")
          ? optionValues.scrollHeight + "px"
          : null;
        break;
      }
      case "apply-filters":
        document.querySelector("main-collection").filtersUpdate();
        this.querySelector("[data-popup-close]").click();
        break;
      case "remove-filters":
        this.querySelectorAll("input:checked").forEach((input) => (input.checked = false));
        document.querySelector("main-collection").filtersUpdate();
        this.querySelector("[data-popup-close]").click();
        break;
    }
  }

  getParams() {
    const searchParams = new URLSearchParams();
    this.querySelectorAll("input:checked").forEach((input) => {
      searchParams.append(input.name, input.value);
    });
    return searchParams.toString();
  }

  updateOptions(html) {
    const section = html.querySelector(`[data-section="${this.dataset.section}"]`);
    const filtersBlock = section?.querySelector("filters-drawer");
    if (!filtersBlock) return;

    if (this.querySelector(".filters__options") && filtersBlock.querySelector(".filters__options")) {
      this.querySelectorAll(".filters__options").forEach((selectorElement, i) => {
        selectorElement.innerHTML = filtersBlock.querySelectorAll(".filters__options")[i].innerHTML;
      });
      this.openAllOptions();
    }
  }
}

if (document.querySelector("filters-drawer")) {
  customElements.define("filters-drawer", FiltersDrawer);
}

class MainBlog extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
    this.initClickEvents();
  }

  initClickEvents() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-action")) {
        switch (e.target.dataset.action) {
          case "switch-blog":
            this.querySelector('[data-tabs] .active').classList.remove("active");
            e.target.classList.add("active");
            this.switchBlog(e.target.dataset.blog);
            break;
        }
      }
    });
  }

  switchBlog(handle) {
    this.toggleLoading();

    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("page", 1);
    const newBlogUrl = "/blogs/" + handle + "?" + searchParams.toString();

    window.history.replaceState({}, '', "/blogs/" + handle);

    fetch(newBlogUrl)
    .then(res => res.text())
    .then(body => {
      const html = new DOMParser().parseFromString(body, "text/html");
      this.renderContent(html);
    })
    .catch(error => console.error(error))
    .finally(() => this.toggleLoading());
  }

  renderContent(html) {
    const section = html.querySelector(`[data-section="${this.dataset.section}"]`);
    const selectors = [
      "[data-title]",
      "[data-grid]",
      "[data-pagination]"
    ];

    selectors.forEach(selector => {
      if (this.querySelector(selector) && section.querySelector(selector)) {
        this.querySelector(selector).innerHTML = section.querySelector(selector).innerHTML;
      }
    });

    if (document.querySelector(".faq__blocks") && section.querySelector(".faq__blocks")) {
      document.querySelector(".faq__blocks").innerHTML = section.querySelector(".faq__blocks").innerHTML;
    }

    if (document.querySelector(".main-video") && section.querySelector(".main-video")) {
      document.querySelector(".main-video").innerHTML = section.querySelector(".main-video").innerHTML;
      document.querySelector(".main-video").videoInit();
    }
  }

  toggleLoading() {
    this.isLoading = !this.isLoading;
    this.classList.toggle("loading", this.isLoading);
  }
}

if (document.querySelector("main-blog")) {
  customElements.define("main-blog", MainBlog);
}

class MainSearch extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;

    this.initClickEvents();
  }

  initClickEvents() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-action")) {
        switch (e.target.dataset.action) {
          case "open-options":
            this.querySelector("[data-sort]").classList.add("open");
            break;
          case "select-option":
            this.querySelector("[name='sort_by']").value = e.target.dataset.option;
            this.filtersUpdate();
            break;
          case "clear-search":
            const input = this.querySelector(".main-search__form-input");
            input.value = "";
            input.focus();
            break;
        }
      }
    });

    window.addEventListener("click", (e) => {
      const sort = this.querySelector("[data-sort]");
      if (sort && !e.target.closest("[data-sort]")) {
        sort.classList.remove("open");
      }
    });
  }

  filtersUpdate() {
    this.toggleLoading();

    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("sort_by", this.querySelector("[name='sort_by']").value);
    const newUrl = window.location.pathname + `?${searchParams.toString()}`;

    window.history.replaceState({}, "", newUrl);

    fetch(newUrl)
      .then((res) => res.text())
      .then((body) => {
        const html = new DOMParser().parseFromString(body, "text/html");
        this.renderContent(html);
      })
      .catch((error) => console.error(error))
      .finally(() => this.toggleLoading());
  }

  renderContent(html) {
    const section = html.querySelector(`[data-section="${this.dataset.section}"]`);
    const selectors = [
      "[data-headings]",
      "[data-grid]",
      "[data-pagination]",
    ];

    selectors.forEach((selector) => {
      if (this.querySelector(selector) && section.querySelector(selector)) {
        this.querySelectorAll(selector).forEach((selectorElement, i) => {
          selectorElement.innerHTML = section.querySelectorAll(selector)[i].innerHTML;
        });
      }
    });
  }

  toggleLoading() {
    this.isLoading = !this.isLoading;
    this.classList.toggle("loading", this.isLoading);
  }
}

if (document.querySelector("main-search")) {
  customElements.define("main-search", MainSearch);
}

// --- COMPONENTS --- //

class SliderComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.currentSlide = 1;
    this.allowEvents = this.getAttribute("data-allow-events") === "true";
    this.hideControls = this.getAttribute("data-hide-controls") !== "false"

    this.slider = this.querySelector('[id^="Slider-"]');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    this.scrollbar = this.querySelector("[slider-scrollbar]");
    this.scrollbarThumb = this.querySelector("[slider-scrollbar] span");

    this.pagination = this.querySelector('[slider-pagination]');

    this.counter = this.querySelector('[slider-counter]');

    if (!this.slider) return;

    this.update();
    window.addEventListener('resize', this.update.bind(this));
    this.slider.addEventListener('scroll', this.update.bind(this));

    if (this.prevButton && this.nextButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    if (this.pagination) {
      this.pagination.addEventListener("click", this.onDotClick.bind(this))
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    if (event.currentTarget.name === 'previous' && this.currentSlide > 1) {
      this.currentSlide -= 1;
    } else if (event.currentTarget.name === 'next' && this.currentSlide < this.maxLength) {
      this.currentSlide += 1;
    }
    this.scrollToSlide(this.currentSlide);
  }

  onDotClick(event) {
    event.preventDefault();
    if (!event.target.hasAttribute("data-slide")) return;

    const slideIndex = parseInt(event.target.dataset.slide);
    this.scrollToSlide(slideIndex);
  }

  scrollToSlide(index) {
    this.slider.scrollTo({
      left: this.querySelector(`[id^="Slide-"]:nth-child(${index})`).offsetLeft,
      behavior: 'smooth'
    });
  }

  update() {
    const items = this.querySelectorAll('[id^="Slide-"]');
    const scrollLeft = this.slider.scrollLeft;
    const scrollWidth = this.slider.scrollWidth;
    const clientWidth = this.slider.clientWidth;
    const blockWidth = parseFloat(getComputedStyle(items[0]).getPropertyValue("width")) || 0;
    const gap = parseInt(getComputedStyle(this.slider).getPropertyValue("gap")) || 0;
    const hasScroll = this.slider.scrollWidth > clientWidth;
      
    this.maxLength = items.length - (Math.floor((clientWidth + gap) / (blockWidth + gap)) - 1);
    
    this.currentSlide = Math.round(scrollLeft / (blockWidth + gap)) + 1;

    items.forEach((item, index) => item.classList.toggle("active", index + 1 == this.currentSlide));
    
    if (this.prevButton && this.nextButton) {
      this.prevButton.toggleAttribute("disabled", this.currentSlide == 1);
      this.nextButton.toggleAttribute("disabled", this.currentSlide == this.maxLength);
  
      if (this.hideControls) {
        this.prevButton.classList.toggle("hidden", !hasScroll);
        this.nextButton.classList.toggle("hidden", !hasScroll);
      }
    }

    if (this.scrollbarThumb) {      
      const thumbWidth = (clientWidth / scrollWidth) * 100;
      const thumbPosition = (scrollLeft / (scrollWidth - clientWidth)) * 100;

      this.scrollbarThumb.style.left = `${thumbPosition}%`;
      this.scrollbarThumb.style.width = `${thumbWidth}%`;
      this.scrollbarThumb.style.transform = `translateX(-${thumbPosition}%)`;
      this.scrollbar.classList.toggle("hidden", !hasScroll);
    }

    if (this.pagination) {
      this.updatePagination();
    }

    if (this.counter) {
      this.counter.innerHTML = `${this.currentSlide} / ${items.length}`;
    }
  
    if (this.allowEvents) {
      this.dispatchEvent(
        new CustomEvent("slider-updated", {
          detail: {
            currentSlide: this.currentSlide
          },
          bubbles: true,
        })
      );
    }
  }

  updatePagination() {
    const slides = this.querySelectorAll('[id^="Slide-"]');

    if (!this.slider || slides.length === 0 || !this.pagination) return;

    const containerWidth = this.slider.clientWidth;
    const slideWidth = slides[0].offsetWidth;

    const slidesPerPage = Math.floor(containerWidth / slideWidth);
    const totalPages = slides.length - (slidesPerPage - 1);

    this.pagination.innerHTML = '';
    this.pagination.classList.toggle("hidden", totalPages === 1);

    for (let i = 1; i <= totalPages; i++) {
      const dot = document.createElement('span');
      dot.setAttribute("data-slide", i);
      if (i === this.currentSlide) dot.classList.add("active");
      this.pagination.appendChild(dot);
    }
  }
}

customElements.define("slider-component", SliderComponent);

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
    this.cart = document.querySelector("cart-drawer");
  }

  connectedCallback() {
    this.addEventListener("click", this.onClick.bind(this));
  }

  onClick(event) {
    if (!event.target.hasAttribute("data-action")) return;

    switch (event.target.dataset.action) {
      case "add-product":
        this.addToCart(event.target);
        break;
    }
  }

  addToCart(button) {
    if (this.isLoading || !button.dataset.variant) return;

    this.toggleLoading();

    const cartData = {
      items: [
        {
          id: parseInt(button.dataset.variant),
          quantity: 1
        }
      ],
      sections_url: window.location.pathname
    };

    if (this.cart) cartData.sections = ["cart-drawer"];

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) throw new Error(response.description);

      if (this.cart) {
        this.cart.renderContent(response.sections);
        this.cart.open();
      } else {
        this.updateCartCount();
      }
    })
    .catch(error => console.error(error))
    .finally(() => this.toggleLoading());
  }

  updateCartCount() {
    fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => {
      document.querySelectorAll("[cart-item-count]").forEach(el => el.textContent = cart.item_count);
    })
    .catch(error => console.error(error));
  }

  toggleLoading() {
    this.isLoading = !this.isLoading;
    this.classList.toggle("loading", this.isLoading);
  }
}

customElements.define("product-card", ProductCard);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;

    this.initClickEvents();
  }

  connectedCallback() {
    this.initClickEvents();
    this.syncDiscounts();

    document.addEventListener("click", (e) => {
      if (e.target.hasAttribute("cart-drawer-toggle")) {
        this.open();
      }
    })
  }

  updateQuantity(item, quantity, itemEl = false) {
    this.toggleLoading(itemEl);

    const lineItems = [...this.querySelectorAll("[data-item]")];
    const updates = lineItems.map((el) => {
      const line = parseInt(el.dataset.item);
      const currentQty = parseInt(el.querySelector('[name="quantity"]')?.value);
      return line === item ? quantity : currentQty;
    });

    const targetDiscounts = this.computeTargetDiscounts({ [item]: quantity });

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates: updates,
        discount: targetDiscounts.join(","),
        sections: ["cart-drawer"],
        sections_url: window.location.pathname
      })
    })
    .then(response => response.json())
    .then(response => {
      if (!response.sections) throw new Error(response.description || "Cart update failed");
      this.renderContent(response.sections);
    })
    .catch((error) => {
      const errItemEl = this.querySelector(`[data-item="${item}"]`);
      const messageBlock = errItemEl?.querySelector("[item-notification]");

      console.error('Error:', error);

      if (messageBlock) {
        messageBlock.innerText = error.message;
        setTimeout(() => {messageBlock.innerText = ""}, 5000);
      }
    })
    .finally(() => {this.toggleLoading(itemEl)});
  }

  renderContent(sections) {
    if (!sections['cart-drawer']) return;

    const html = new DOMParser().parseFromString(sections['cart-drawer'], "text/html");
    const newCartDrawer = html.querySelector("cart-drawer");
    
    this.querySelector("[js-content-items]").innerHTML = newCartDrawer.querySelector("[js-content-items]").innerHTML;
    this.querySelector("[js-content-footer]").innerHTML = newCartDrawer.querySelector("[js-content-footer]").innerHTML;
    this.setAttribute("data-count", newCartDrawer.dataset.count);
    this.querySelector("[cart-count]").textContent = `( ${newCartDrawer.dataset.count} )`;

    // if (this.querySelector('[data-progress="shipping"]')) {
    //   this.querySelector('[data-progress="shipping"]').style.width = newCartDrawer.querySelector('[data-progress="shipping"]').style.width;
    //   this.querySelector('.cart-drawer__achivements-label').innerHTML = newCartDrawer.querySelector('.cart-drawer__achivements-label').innerHTML;
    // }

    document.querySelectorAll("[cart-item-count]").forEach(countEl => countEl.innerText = newCartDrawer.dataset.count);

    this.dataset.requiredDiscounts = newCartDrawer.dataset.requiredDiscounts || "";
    this.dataset.managedDiscounts = newCartDrawer.dataset.managedDiscounts || "";
    this.dataset.appliedDiscounts = newCartDrawer.dataset.appliedDiscounts || "";
    this.syncDiscounts();
  }

  parseDiscountMap(value) {
    const map = {};

    (value || "")
      .split("||")
      .map((pair) => pair.trim())
      .filter(Boolean)
      .forEach((pair) => {
        const separator = pair.indexOf(":");
        if (separator === -1) return;
        const quantity = pair.slice(0, separator).trim();
        const code = pair.slice(separator + 1).trim();
        if (quantity && code) map[quantity] = code;
      });

    return map;
  }

  resolveDiscountCode(discountMap, quantity) {
    let bestQuantity = 0;
    let bestCode = "";

    Object.keys(discountMap).forEach((key) => {
      const optionQuantity = parseInt(key);
      if (!isNaN(optionQuantity) && optionQuantity <= quantity && optionQuantity > bestQuantity) {
        bestQuantity = optionQuantity;
        bestCode = discountMap[key];
      }
    });

    return bestCode;
  }

  parseDiscountCodes(value) {
    return (value || "")
      .split(",")
      .map((code) => code.trim())
      .filter(Boolean);
  }

  computeTargetDiscounts(quantityOverrides = {}, extraCodes = []) {
    const managed = this.parseDiscountCodes(this.dataset.managedDiscounts);
    const applied = this.parseDiscountCodes(this.dataset.appliedDiscounts);
    const manual = applied.filter((code) => !managed.includes(code));

    const required = [];
    this.querySelectorAll("[data-item]").forEach((itemEl) => {
      const line = itemEl.dataset.item;
      const discountMap = this.parseDiscountMap(itemEl.dataset.discountMap);
      const quantity = Object.prototype.hasOwnProperty.call(quantityOverrides, line)
        ? quantityOverrides[line]
        : parseInt(itemEl.querySelector('[name="quantity"]')?.value);

      const code = this.resolveDiscountCode(discountMap, quantity);
      if (code) required.push(code);
    });

    return [...new Set([...manual, ...required, ...extraCodes.filter(Boolean)])];
  }

  applyDiscountsAndRender(targetCodes) {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        discount: targetCodes.join(","),
        sections: ["cart-drawer"],
        sections_url: window.location.pathname
      })
    })
    .then((response) => response.json())
    .then((response) => {
      if (response.sections) this.renderContent(response.sections);
      return response;
    });
  }

  syncDiscounts() {
    const required = this.parseDiscountCodes(this.dataset.requiredDiscounts);
    const managed = this.parseDiscountCodes(this.dataset.managedDiscounts);
    const applied = this.parseDiscountCodes(this.dataset.appliedDiscounts);

    const manual = applied.filter((code) => !managed.includes(code));
    const target = [...new Set([...manual, ...required])];

    const isSynced = target.length === applied.length && target.every((code) => applied.includes(code));

    if (isSynced) {
      this.discountSyncAttempts = 0;
      return;
    }

    // Guard against loops when Shopify silently drops an invalid/expired code.
    if (this.discountSyncAttempts >= 2) {
      console.warn("Cart discounts: unable to sync codes", { target, applied });
      return;
    }
    this.discountSyncAttempts = (this.discountSyncAttempts || 0) + 1;

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        discount: target.join(","),
        sections: ["cart-drawer"],
        sections_url: window.location.pathname
      })
    })
    .then((response) => response.json())
    .then((response) => {
      if (response.sections) this.renderContent(response.sections);
    })
    .catch((error) => console.error("Cart discounts sync error:", error));
  }

  addItemToCart(item, itemEl = false) {
    this.toggleLoading(itemEl);

    const sections = ["cart-drawer"];

    const cartData = {
      items: [
        {
          id: parseInt(item),
          quantity: 1
        }
      ],
      sections: sections,
      sections_url: window.location.pathname
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) {
        throw new Error(response.description);
      } else {
        this.renderContent(response.sections);
      }
    })
    .catch(error => console.error(error))
    .finally(() => this.toggleLoading(itemEl));
  }

  initClickEvents() {
    this.addEventListener("click", (e) => {
      e.preventDefault();

      const item = e.target.closest("[data-item]");
      const itemQuantityInput = item?.querySelector('[name="quantity"]') ?? false;
      const itemQuantity = parseInt(itemQuantityInput?.value) ?? false;

      switch (e.target.dataset.action) {
        case "close":
          this.close();
          break;
        case "remove-item":
          if (!this.isLoading) {
            this.updateQuantity(parseInt(item.dataset.item), 0, item);
          }
          break;
        case "decrease-quantity":          
          if (itemQuantity > 1) {
            if (!this.isLoading) {
              this.updateQuantity(parseInt(item.dataset.item), parseInt(itemQuantity - 1), item);
            }
          }
          break;
        case "increase-quantity":
          if (itemQuantity < 199) {
            if (!this.isLoading) {
              this.updateQuantity(parseInt(item.dataset.item), parseInt(itemQuantity + 1), item);
            }
          }
          break;
        case "add-product":
          if (!this.isLoading) {
            this.addItemToCart(e.target.dataset.variant, e.target);
          }
          break;
        case "to-checkout":
          window.location.pathname = "/checkout";
          break;
      }
    })
  }

  toggleLoading(itemEl) {
    this.isLoading = !this.isLoading;
    this.classList.toggle("loading-item", this.isLoading);

    if (itemEl) {
      itemEl.classList.toggle("loading", this.isLoading);
    }
  }

  open() {
    this.classList.add("open");
    document.documentElement.style.overflow = "hidden";
  }

  close() {
    this.classList.remove("open");
    document.documentElement.style.overflow = null;
  }
}

if (document.querySelector("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}

class Localization extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initClickEvents();

    document.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-localization-open")) {
        this.open();
      }
    })
  }

  initClickEvents() {
    this.addEventListener("click", (e) => {
      e.preventDefault();
      const form = this.querySelector("form");
      switch (e.target.dataset.action) {
        case "close":
          form.classList.remove("open");
          this.close();
          break;
        case "toggle-options":
          form.classList.toggle("open");
          break;
        case "select-option":
          const selected = this.querySelector('[data-action="toggle-options"]');
          selected.innerHTML = e.target.innerHTML;
          form.classList.remove("open");
          form.querySelector("[name='country_code']").value = e.target.dataset.value;
          break;
        case "save":
          this.close();
          form.submit();
          break;
      }
    })
  }

  open() {
    this.classList.add("open");
    document.documentElement.style.overflow = "hidden";
  }

  close() {
    this.classList.remove("open");
    document.documentElement.style.overflow = null;
  }
}


if (document.querySelector("localization-popup")) {
  customElements.define("localization-popup", Localization);
}

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector(".header");
  }

  connectedCallback() {
    this.input = this.querySelector("[data-search-input]");
    this.results = this.querySelector("[data-results]");

    this.addEventListener("click", this.onClick.bind(this));
    document.addEventListener("click", this.onDocumentClick.bind(this));

    if (this.input) {
      this.input.addEventListener("input", debounce(this.onSearch.bind(this), 300));
    }
  }

  onDocumentClick(event) {
    if (event.target.closest('[data-action="open-search"]')) {
      event.preventDefault();
      // The header search icon toggles the panel (search glyph <-> close glyph)
      this.classList.contains("open") ? this.close() : this.open();
      return;
    }

    // Click outside the open panel closes it
    if (this.classList.contains("open") && !event.target.closest("predictive-search")) {
      this.close();
    }
  }

  onClick(event) {
    if (!event.target.hasAttribute("data-action")) return;

    switch (event.target.dataset.action) {
      case "clear-search":
        this.clear();
        break;
      case "switch-category":
        this.switchCategory(event.target.dataset.collection);
        break;
    }
  }

  open() {
    // Close the mobile menu if it's open — the two panels shouldn't overlap
    const mobileMenu = document.querySelector("#HeaderMobileMenu.open");
    if (mobileMenu) mobileMenu.classList.remove("open");

    // Measure the header's real bottom edge so the panel sits right under it (mid-scroll included)
    if (this.header) {
      const offset = Math.max(this.header.getBoundingClientRect().bottom, 0);
      this.style.setProperty("--menu-offset", `${offset}px`);
    }

    this.classList.add("open");
    document.documentElement.style.overflow = "hidden";
    setTimeout(() => this.input && this.input.focus(), 50);
  }

  close() {
    this.classList.remove("open");
    document.documentElement.style.overflow = null;
  }

  // The bar button both clears the query and, when already empty, closes the panel
  clear() {
    if (!this.input.value) {
      this.close();
      return;
    }

    this.input.value = "";
    this.classList.remove("searching");
    this.results.innerHTML = "";
    this.input.focus();
  }

  switchCategory(handle) {
    this.querySelectorAll(".predictive__tab").forEach((tab) => {
      tab.classList.toggle("is-active", tab.dataset.collection === handle);
    });

    this.querySelectorAll(".predictive__grid[data-collection]").forEach((grid) => {
      grid.classList.toggle("hidden", grid.dataset.collection !== handle);
    });
  }

  onSearch() {
    const query = this.input.value.trim();

    this.classList.toggle("searching", query.length > 0);

    if (!query) {
      this.results.innerHTML = "";
      return;
    }

    this.classList.add("loading");

    const url = `${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10&section_id=predictive-search-results`;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, "text/html");
        const section = html.querySelector("#shopify-section-predictive-search-results");
        this.results.innerHTML = section ? section.innerHTML : "";
      })
      .catch((error) => console.error(error))
      .finally(() => this.classList.remove("loading"));
  }
}

if (document.querySelector("predictive-search")) {
  customElements.define("predictive-search", PredictiveSearch);
}

class BackInStock extends HTMLElement {
  constructor() {
    super();
    this.onDocumentClick = this.onDocumentClick.bind(this);
    // Global trigger listener — attached once (the popup is reparented by window.Popup on open,
    // so binding here in the constructor avoids double-binding on reconnect).
    document.addEventListener("click", this.onDocumentClick);
  }

  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.form = this.querySelector(".back-in-stock__form");
    this.form?.addEventListener("submit", (event) => {
      event.preventDefault();
      this.submit();
    });
  }

  onDocumentClick(event) {
    const trigger = event.target.closest('[data-action="open-back-in-stock"]');
    if (!trigger) return;
    event.preventDefault();
    this.open(trigger);
  }

  open(trigger) {
    // main-product: use the live selected variant; product-card: use the trigger's data-variant.
    let variantId = trigger.dataset.variant;
    const mainProduct = trigger.closest("main-product");
    if (mainProduct) {
      variantId = mainProduct.querySelector("[name='id']")?.value || variantId;
    }
    this.variantId = variantId;

    this.classList.remove("success", "error", "loading");
    this.form?.reset();

    window.Popup?.open("BackInStock");
    setTimeout(() => this.querySelector("input[type='email']")?.focus(), 100);
  }

  submit() {
    if (this.classList.contains("loading") || !this.variantId) return;

    const email = this.querySelector("input[type='email']")?.value?.trim();
    if (!email) return;

    const companyId = this.dataset.companyId;
    if (!companyId) {
      console.error("Back in stock: Klaviyo company id is not set");
      this.classList.add("error");
      return;
    }

    this.classList.remove("error", "success");
    this.classList.add("loading");

    const headers = {
      revision: "2024-02-15",
      "Content-Type": "application/json",
      "X-Klaviyo-Onsite": "1",
    };

    const requests = [
      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${companyId}`, {
        method: "POST",
        headers,
        body: JSON.stringify({
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              profile: { data: { type: "profile", attributes: { email } } },
              channels: ["EMAIL"],
            },
            relationships: {
              variant: {
                data: { type: "catalog-variant", id: `$shopify:::$default:::${this.variantId}` },
              },
            },
          },
        }),
      }),
    ];

    // Newsletter list subscription — only when the consent checkbox is kept on.
    const consent = this.querySelector(".back-in-stock__consent-input");
    const listId = this.dataset.listId;
    if (consent?.checked && listId) {
      requests.push(
        fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`, {
          method: "POST",
          headers,
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email,
                      subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } },
                    },
                  },
                },
              },
              relationships: { list: { data: { type: "list", id: listId } } },
            },
          }),
        })
      );
    }

    Promise.all(requests)
      .then((responses) => {
        this.classList.remove("loading");
        this.classList.add(responses.every((response) => response.ok) ? "success" : "error");
      })
      .catch((error) => {
        console.error("Back in stock error:", error);
        this.classList.remove("loading");
        this.classList.add("error");
      });
  }
}

if (document.querySelector("back-in-stock")) {
  customElements.define("back-in-stock", BackInStock);
}